import { RoomEvent, MatrixEvent, Room } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { roomService } from '../roomService';
import { matrixClient } from '../../client';

const fileLogger = new Log(false, 'im.client.room.handlers.timeline');
fileLogger.childrenPaused = true;
function onRoomTimeline(event: MatrixEvent, room: Room | undefined, toStartOfTimeline?: boolean) {
    const logger = fileLogger.sub(false, 'onRoomTimeline');
    logger.pause = true;
    if (toStartOfTimeline || !room) {
        return; // 跳过历史消息
    }

    const roomId = room.roomId;
    logger.log(`Timeline event in room ${room.name} (${roomId}):`, event.getType());

    // 更新房间最后消息时间
roomService.addOrUpdateRoomInfo({
        roomId,
        name: room.name,
        lastMessageTime: event.getTs()
    });
}

export const timelineHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(RoomEvent.Timeline, onRoomTimeline);
    }
};
